import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  root: {
    width: '100%',
  },
  label: {
    ...theme.mixins.appLabel,
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(2),
  },
  labelContainer: {
    width: '100%',
    position: 'relative',
  },
  helperText: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(0.5),
  },
  chipsContainer: {
    position: 'relative',
    display: 'flex',
    overflow: 'auto',
    gap: theme.spacing(1),
    alignItems: 'center',
    minHeight: theme.spacing(6),
    maxHeight: theme.spacing(6),
    padding: theme.spacing(1),
    paddingRight: theme.spacing(4),
    border: `1px solid ${theme.palette.input.dark}`,
    borderRadius: '10px',
    letterSpacing: '0.5px',
    backgroundColor: theme.palette.input.main,
    color: theme.palette.input.contrastText,
  },
  chipsContent: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
    overflowX: 'auto',
    overflowY: 'hidden',
  },
  arrowIcon: {
    position: 'absolute',
    right: theme.spacing(1),
    top: '50%',
    transform: 'translateY(-50%)',
    width: 24,
    height: 24,
    color: theme.palette.input.contrastText,
    flexShrink: 0,
    pointerEvents: 'none',
    transition: 'transform 0.2s ease',
  },
  arrowIconOpen: {
    transform: 'translateY(-50%) rotate(180deg)',
  },
  chipsContainerClickable: {
    cursor: 'pointer',
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  chip: {
    height: theme.spacing(3.75),
    margin: 0,
    maxWidth: `calc(100% - 80px)`,

    '& button': {
      margin: '0 !important',
    },
  },
  chipClickable: {
    cursor: 'pointer',
  },
  chipWithDelete: {
    '& .MuiChip-label': {
      paddingRight: 0,
    },
  },
  chipWithAvatar: {
    paddingLeft: theme.spacing(1),
    '& .MuiChip-label': {
      paddingLeft: theme.spacing(0.5),
    },
  },
  addButton: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:disabled': {
      color: theme.palette.action.disabled,
    },
  },
  menuPaper: {
    maxHeight: theme.spacing(50),
    [theme.breakpoints.down('md')]: {
      maxHeight: `${MAX_PAGE_HEIGHT} !important`,
    },
  },
  menuList: {
    padding: 0,
    maxHeight: theme.spacing(50),
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      maxHeight: 'none',
      flex: 1,
      minHeight: 0,
    },
  },
  menuItem: {
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  checkBox: {
    color: theme.palette.primary.main,
    padding: theme.spacing(0.5),
  },
  searchField: {
    backgroundColor: theme.palette.input.main,
    '& .MuiInputBase-input': {
      color: theme.palette.input.contrastText,
    },
    '& .MuiInputBase-input::placeholder': {
      color: theme.palette.input.placeholderText,
      opacity: 1,
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.input.main,
      '& fieldset': {
        borderColor: theme.palette.input.dark,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.input.dark,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
}));
